import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Form, Nav, Navbar, Button } from 'react-bootstrap';

const NavbarMenu = () => {
    return (
        <div>
            <Navbar bg="dark" variant='dark'>
                <h1 className='logo'><Link to="/">NETFLIX</Link></h1>
                <Nav className="me-auto">
                    <Nav.Link href="/">Home</Nav.Link>
                    <Nav.Link href="/movies">Movies</Nav.Link>
                </Nav>
                <Form className="d-flex">
                    <Form.Control
                        type="search"
                        placeholder="Search"
                        className="me-2"
                        aria-label="Search"
                    />
                    <Button type="button">Search</Button>
                </Form>
            </Navbar>


        </div>
    )
}

export default NavbarMenu